import type { Options } from 'ky';

import type { TelegramUser } from '@api';

import type { ApiOptions } from './ApiProvider';
import Api from './ApiProvider';

export const deleteUserSocial = ({ id }: { id: number }) =>
  Api.delete(`v2/magicid/user/socials/common/${id}`).json<{
    createdAt: string;
    id: number;
    isVerified: number;
    link: string;
    social: string;
    updatedAt: boolean;
    userId: number;
    visibleOnMagicId: boolean;
  }>();

export const getDiscordLink = (from: string, options?: Options) =>
  Api.get('v2/magicid/user/socials/discord/connect', { searchParams: { from }, ...options }).json<{
    url: string;
  }>();

export const verifyDiscord = (options: ApiOptions<{ json: { code: string; state: string } }>) =>
  Api.post('v2/magicid/user/socials/discord/verify', options).json();

export const getTwitterLink = () =>
  Api.get('v1/magicid/socials/twitter/generateVerifyMessage').json<{
    urlWithMessage: string;
    verifyMessage: string;
  }>();

export const verifyTwitterLink = (options: ApiOptions<{ json: { tweetUrl: string } }>) =>
  Api.post('v1/magicid/socials/twitter/verify', options);

export const connectTelegram = (options: ApiOptions<{ json: { userData: TelegramUser } }>) =>
  Api.post('v2/magicid/user/socials/telegram/verify', options).json();

export const getConnectXUrl = ({ from }: { from: string }, options?: ApiOptions) =>
  Api.get('v2/magicid/user/socials/x/connect', { searchParams: { from }, ...options }).json<{
    meta: { link: string };
  }>();

export interface VerifyXConnectParams {
  oauthToken: string;
  oauthVerifier: string;
}

export const verifyXConnect = (options: ApiOptions<{ json: VerifyXConnectParams }>) => {
  return Api.post('v2/magicid/user/socials/x/verify', options).json();
};
